var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "amprocess-new pb-1" }, [
    !_vm.isDataLoaded
      ? _c("div", [_vm._v(_vm._s(_vm.$t("loading")))])
      : _c("div", [
          !_vm.showAmpTable
            ? _c("div", { staticClass: "flex-row" })
            : _c("div", [
                _c(
                  "div",
                  { staticClass: "flex-row flex-6 flex-justify-center" },
                  [
                    _c("div", { staticClass: "flex-col flex-1" }, [
                      _c("table", [
                        _c("thead", [
                          _c("tr", [
                            _c("th"),
                            _c(
                              "th",
                              {
                                staticClass: "mainheader bl br pb-2",
                                attrs: { colspan: "7" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("maintenanceStrategyAndRisk"))
                                ),
                              ]
                            ),
                            _c("th", { attrs: { colspan: "2" } }),
                            _c(
                              "th",
                              {
                                staticClass: "mainheader bl br pb-2",
                                attrs: { colspan: "9" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("digitalizationComplianceAndSupport")
                                  )
                                ),
                              ]
                            ),
                          ]),
                          _c(
                            "tr",
                            [
                              _c("th"),
                              _vm._l(
                                _vm.decisionModelListLocal,
                                function (decisionModel) {
                                  return _c(
                                    "th",
                                    {
                                      key: decisionModel.id,
                                      staticClass: "sub-category",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "rotate rotate-text" },
                                        [_vm._v(_vm._s(decisionModel.category))]
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ]),
                        _c("tbody", [
                          _c(
                            "tr",
                            [
                              _c("td", { staticClass: "category" }, [
                                _vm._v(_vm._s(_vm.grow)),
                              ]),
                              _vm._l(
                                _vm.decisionModelListLocal,
                                function (decisionModel, index) {
                                  return _c(
                                    "td",
                                    {
                                      key: decisionModel.id,
                                      staticClass: "tooltip",
                                      class: {
                                        darkGreenBox:
                                          decisionModel.process == _vm.grow,
                                        handCursor: _vm.isInEditMode,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.processSelection(
                                            index,
                                            _vm.grow
                                          )
                                        },
                                      },
                                    },
                                    [
                                      decisionModel.process === "Grow Value"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                class: _vm.hoverPosition(index),
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "hover-box-title mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          decisionModel.category
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getLosDescription(
                                                          decisionModel.category,
                                                          "Grow Value"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _c(
                            "tr",
                            [
                              _c("td", { staticClass: "category" }, [
                                _vm._v(_vm._s(_vm.maintain)),
                              ]),
                              _vm._l(
                                _vm.decisionModelListLocal,
                                function (decisionModel, index) {
                                  return _c(
                                    "td",
                                    {
                                      key: decisionModel.id,
                                      staticClass: "tooltip",
                                      class: {
                                        lightGreenBox:
                                          decisionModel.process == _vm.maintain,
                                        handCursor: _vm.isInEditMode,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.processSelection(
                                            index,
                                            _vm.maintain
                                          )
                                        },
                                      },
                                    },
                                    [
                                      decisionModel.process === "Maintain Value"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                class: _vm.hoverPosition(index),
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "hover-box-title mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          decisionModel.category
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getLosDescription(
                                                          decisionModel.category,
                                                          "Maintain Value"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _c(
                            "tr",
                            [
                              _c("td", { staticClass: "category" }, [
                                _vm._v(_vm._s(_vm.keepOption)),
                              ]),
                              _vm._l(
                                _vm.decisionModelListLocal,
                                function (decisionModel, index) {
                                  return _c(
                                    "td",
                                    {
                                      key: decisionModel.id,
                                      staticClass: "tooltip",
                                      class: {
                                        yellowBox:
                                          decisionModel.process ==
                                          _vm.keepOption,
                                        handCursor: _vm.isInEditMode,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.processSelection(
                                            index,
                                            _vm.keepOption
                                          )
                                        },
                                      },
                                    },
                                    [
                                      decisionModel.process === "Keep Option"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                class: _vm.hoverPosition(index),
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "hover-box-title mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          decisionModel.category
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getLosDescription(
                                                          decisionModel.category,
                                                          "Keep Option"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _c(
                            "tr",
                            [
                              _c("td", { staticClass: "category" }, [
                                _vm._v(_vm._s(_vm.optimizeEol)),
                              ]),
                              _vm._l(
                                _vm.decisionModelListLocal,
                                function (decisionModel, index) {
                                  return _c(
                                    "td",
                                    {
                                      key: decisionModel.id,
                                      staticClass: "tooltip",
                                      class: {
                                        redBox:
                                          decisionModel.process ==
                                          _vm.optimizeEol,
                                        handCursor: _vm.isInEditMode,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.processSelection(
                                            index,
                                            _vm.optimizeEol
                                          )
                                        },
                                      },
                                    },
                                    [
                                      decisionModel.process === "Optimize EOL"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                class: _vm.hoverPosition(index),
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "hover-box-title mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          decisionModel.category
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getLosDescription(
                                                          decisionModel.category,
                                                          "Optimize EOL"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
                _vm.isInEditMode
                  ? _c("div", { staticClass: "flex-row" }, [
                      _c(
                        "div",
                        { staticClass: "flex-col flex-1 edit-comment" },
                        [
                          _c("div", { staticClass: "mt-3 am-comment" }, [
                            _c(
                              "label",
                              {
                                staticClass: "perf-label",
                                attrs: { for: "updComment" },
                              },
                              [_vm._v(_vm._s(_vm.$t("reason")))]
                            ),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.updComment,
                                  expression: "updComment",
                                },
                              ],
                              class: {
                                "comment-input": true,
                                invalid: _vm.isCommentEmpty,
                              },
                              attrs: {
                                id: "updComment",
                                placeholder: _vm.$t("reason"),
                                maxlength: "250",
                                rows: "4",
                              },
                              domProps: { value: _vm.updComment },
                              on: {
                                keyup: function ($event) {
                                  return _vm.updateComponentInRealTime()
                                },
                                focus: () => (_vm.isCommentEmpty = false),
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.updComment = $event.target.value
                                },
                              },
                            }),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }